export default __webpack_public_path__ + "static/media/BirdPage2.97a47883.txt";